import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementConfigurationByDate } from '@api/manageNetworkElementConfigurations';

import {
	INetworkElementConfigurationsByDateDTO,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import {
	INetworkElementConfigurationView,
} from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { NETWORK_ELEMENT_CONFIGURATION_BY_DATE } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationByDateReturned {
	networkElementConfiguration?: INetworkElementConfigurationView;
	isLoadingNetworkElementConfiguration: boolean;
	getNetworkElementConfigurationByDate: UseMutateFunction<
		any, any, INetworkElementConfigurationsByDateDTO<number>, any
	>;
}

const useMutateNetworkElementConfigurationByDate = (
	onSuccess: (data: INetworkElementConfigurationView) => void,
): IUseQueryNetworkElementConfigurationByDateReturned => {

	const {
		isLoading,
		mutate,
		data,
	} = useMutation<INetworkElementConfigurationsByDateDTO<number>>({
		mutationKey: [NETWORK_ELEMENT_CONFIGURATION_BY_DATE],
		mutationFn: getNetworkElementConfigurationByDate,
		onSuccess,
	});

	return {
		networkElementConfiguration: data,
		isLoadingNetworkElementConfiguration: isLoading,
		getNetworkElementConfigurationByDate: mutate,
	};
};

export default useMutateNetworkElementConfigurationByDate;
